import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { fromEvent } from 'rxjs';
import { SocketsManagerService } from '../../../sockets-manager/services';
import { WebSocketError } from '../../../sockets-manager/models';

@Component({
  selector: 'app-offline-bar',
  templateUrl: './offline-bar.component.html',
  styleUrls: ['./offline-bar.component.scss']
})
export class OfflineBarComponent implements OnInit {
  private _isLogged!: boolean;
  private timer!: any;
  private TIME_TO_REFRESH: number = 30_000 as const;
  
  @HostBinding('style.display') public display: 'none' | 'block' = 'none';
  
  @Input() public set isLogged(value: boolean | null) {
    this._isLogged = !!value;
  }
  get isLogged(): boolean {
    return this._isLogged;
  }
  
  public isOffline: boolean = !window.navigator.onLine;
  public websocketsNotAvailable: boolean = false;
  public mustRefresh: boolean = false;
  
  constructor(private readonly socketsManager: SocketsManagerService,
              private readonly cdf: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
    this.setListenerForOffline();
    
    this.socketsManager.getErrors$().subscribe((websocketError: WebSocketError[]) => {
      this.websocketsNotAvailable = websocketError.length > 0;
      !this.websocketsNotAvailable && this.hideOfflineBar();
      
      if (this.websocketsNotAvailable) {
        this.timer = setTimeout(() => {
          this.showOfflineBar();
          this.mustRefresh = true;
          clearTimeout(this.timer);
        }, this.TIME_TO_REFRESH);
      } else {
        clearTimeout(this.timer);
        this.mustRefresh = false;
      }
      
      this.cdf.detectChanges();
    });
  }
  
  public reloadPage(): void {
    window.location.reload();
  }
  
  public closeOfflineBar(): void {
    this.hideOfflineBar();
  }
  
  private setListenerForOffline(): void {
    fromEvent(window, 'offline').subscribe(() => {
      this.isOffline = true;
      this.showOfflineBar();
    });
    fromEvent(window, 'online').subscribe(() => {
      this.isOffline = false;
      this.websocketsNotAvailable ? this.showOfflineBar() : this.hideOfflineBar();
    });
  }
  
  private hideOfflineBar(): void {
    this.display = 'none';
    this.cdf.detectChanges();
  }
  
  private showOfflineBar(): void {
    this.display = 'block';
    this.cdf.detectChanges();
  }
}
